import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSearch, FiX, FiArrowRight } from 'react-icons/fi';
import {
    MdDashboard,
    MdOutlinePayments,
    MdNotifications,
    MdPolicy,
    MdOutlineAdminPanelSettings,
    MdPhoneAndroid,
    MdOutlineBugReport
} from 'react-icons/md';
import { FaRegUser, FaAd } from 'react-icons/fa';
import { RiLoginBoxLine, RiDeleteBin6Line, RiSettings3Line } from 'react-icons/ri';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { IoMdLogOut } from 'react-icons/io';
import { BiHistory } from 'react-icons/bi';
import { TbBrandApple, TbBrandAndroid } from 'react-icons/tb';
import { BsFileText, BsPhone } from 'react-icons/bs';
import { AiOutlineApi } from 'react-icons/ai';

const UniversalSearchBar = () => {
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const inputRef = useRef();
    const containerRef = useRef();
    const navigate = useNavigate();

    const searchItems = [
        // Main
        { id: 1, title: "Dashboard", path: "/", category: "Main", icon: <MdDashboard size={18} />, color: "text-blue-500" },
        { id: 2, title: "Controller", path: "/controller", category: "Main", icon: <RiSettings3Line size={18} />, color: "text-purple-500" },
        { id: 3, title: "Profile", path: "/profile", category: "Main", icon: <FaRegUser size={18} />, color: "text-teal-500" },
        { id: 4, title: "Logout", path: "/Logout", category: "Main", icon: <IoMdLogOut size={18} />, color: "text-red-500" },

        // User Management
        { id: 5, title: "All Users", path: "/manage/user/all/data", category: "Users", icon: <FaRegUser size={18} />, color: "text-teal-500" },
        { id: 6, title: "User Login History", path: "/manage/user/login/all/data", category: "Users", icon: <RiLoginBoxLine size={18} />, color: "text-yellow-500" },
        { id: 7, title: "User Delete Requests", path: "/manage/user/all/delete", category: "Users", icon: <RiDeleteBin6Line size={18} />, color: "text-red-500" },
        { id: 8, title: "Referrals", path: "/manage/user/referral/all/data", category: "Users", icon: <HiOutlineUserGroup size={18} />, color: "text-cyan-500" },

        // Plans
        { id: 9, title: "Plans", path: "/manage/plan", category: "Plans", icon: <MdOutlinePayments size={18} />, color: "text-purple-500" },
        { id: 10, title: "Plan History", path: "/manage/plan/history", category: "Plans", icon: <BiHistory size={18} />, color: "text-indigo-500" },
        { id: 11, title: "Referral Plan", path: "/manage/plan/referral", category: "Plans", icon: <MdOutlinePayments size={18} />, color: "text-orange-500" },
        { id: 12, title: "Referral Plan History", path: "/manage/plan/referral/history", category: "Plans", icon: <BiHistory size={18} />, color: "text-orange-400" },

        // Android Ads
        { id: 13, title: "Native Ads (Android)", path: "/manage/ads/nativeAds/add", category: "Android Ads", icon: <TbBrandAndroid size={18} />, color: "text-green-500" },
        { id: 14, title: "Fullscreen Ads (Android)", path: "/manage/ads/fullScreenAds/add", category: "Android Ads", icon: <TbBrandAndroid size={18} />, color: "text-green-500" },
        { id: 15, title: "Banner Ads (Android)", path: "/manage/ads/bannerAds/add", category: "Android Ads", icon: <TbBrandAndroid size={18} />, color: "text-green-500" },
        { id: 16, title: "Open Ads (Android)", path: "/manage/ads/openAds/add", category: "Android Ads", icon: <TbBrandAndroid size={18} />, color: "text-green-500" },
        { id: 17, title: "Reward Ads (Android)", path: "/manage/ads/rewardAds/add", category: "Android Ads", icon: <TbBrandAndroid size={18} />, color: "text-green-500" },
        { id: 18, title: "Reward FS Ads (Android)", path: "/manage/ads/rewardFsAds/add", category: "Android Ads", icon: <TbBrandAndroid size={18} />, color: "text-green-500" },

        // iOS Ads
        { id: 19, title: "Native Ads (iOS)", path: "/manage/ads/ios/nativeAds/add", category: "iOS Ads", icon: <TbBrandApple size={18} />, color: "text-gray-600" },
        { id: 20, title: "Fullscreen Ads (iOS)", path: "/manage/ads/ios/fullScreenAds/add", category: "iOS Ads", icon: <TbBrandApple size={18} />, color: "text-gray-600" },
        { id: 21, title: "Banner Ads (iOS)", path: "/manage/ads/ios/bannerAds/add", category: "iOS Ads", icon: <TbBrandApple size={18} />, color: "text-gray-600" },
        { id: 22, title: "Open Ads (iOS)", path: "/manage/ads/ios/openAds/add", category: "iOS Ads", icon: <TbBrandApple size={18} />, color: "text-gray-600" },
        { id: 23, title: "Reward Ads (iOS)", path: "/manage/ads/ios/rewardAds/add", category: "iOS Ads", icon: <TbBrandApple size={18} />, color: "text-gray-600" },
        { id: 24, title: "Reward FS Ads (iOS)", path: "/manage/ads/ios/rewardAdsFs/add", category: "iOS Ads", icon: <TbBrandApple size={18} />, color: "text-gray-600" },

        // Other Ads
        { id: 25, title: "InHouse Ads", path: "/manage/ads/inHouseAds/add", category: "Ads", icon: <FaAd size={18} />, color: "text-blue-500" },
        { id: 26, title: "Ads Track", path: "/manage/adstrack", category: "Ads", icon: <FaAd size={18} />, color: "text-blue-400" },
        { id: 27, title: "Ads.txt Editor", path: "/manage/ads/txt", category: "Ads", icon: <BsFileText size={18} />, color: "text-gray-500" },

        // Mobile
        { id: 28, title: "Mobile", path: "/manage/mobile/", category: "Mobile", icon: <MdPhoneAndroid size={18} />, color: "text-blue-500" },
        { id: 29, title: "Add Mobile", path: "/manage/mobile/add", category: "Mobile", icon: <MdPhoneAndroid size={18} />, color: "text-blue-400" },
        { id: 30, title: "Whitelist Number", path: "/manage/mobile/whitelistnumber", category: "Mobile", icon: <BsPhone size={18} />, color: "text-green-500" },
        { id: 31, title: "API Config", path: "/manage/mobile/api-config", category: "Mobile", icon: <AiOutlineApi size={18} />, color: "text-purple-500" },

        // ShowBox
        { id: 32, title: "ShowBox", path: "/manage/mobile/showbox/", category: "ShowBox", icon: <MdPhoneAndroid size={18} />, color: "text-indigo-500" },
        { id: 33, title: "Bug Report", path: "/manage/mobile/bugreport", category: "ShowBox", icon: <MdOutlineBugReport size={18} />, color: "text-red-400" },
        { id: 34, title: "ShowBox Analytics", path: "/manage/showboxanalytic", category: "ShowBox", icon: <MdDashboard size={18} />, color: "text-indigo-400" },

        // Notification
        { id: 35, title: "Notification", path: "/notification", category: "Notification", icon: <MdNotifications size={18} />, color: "text-yellow-500" },
        { id: 36, title: "Auto Notification", path: "/manage/mobile/autonotification", category: "Notification", icon: <MdNotifications size={18} />, color: "text-yellow-400" },
        { id: 37, title: "Auto Notification Template", path: "/manage/mobile/autonotificationtemp", category: "Notification", icon: <MdNotifications size={18} />, color: "text-yellow-300" },

        // Policy
        { id: 38, title: "Privacy Policy", path: "/policy", category: "Policy", icon: <MdPolicy size={18} />, color: "text-gray-500" },
        { id: 39, title: "Terms & Conditions", path: "/policy/terms", category: "Policy", icon: <MdPolicy size={18} />, color: "text-gray-500" },
        { id: 40, title: "Privacy Policy (iOS)", path: "/policy/ios", category: "Policy", icon: <TbBrandApple size={18} />, color: "text-gray-600" },
        { id: 41, title: "Terms & Conditions (iOS)", path: "/policy/terms/ios", category: "Policy", icon: <TbBrandApple size={18} />, color: "text-gray-600" },

        // Other
        { id: 42, title: "JSON Manager", path: "/manage/UI/jsonmanager", category: "Settings", icon: <RiSettings3Line size={18} />, color: "text-purple-500" },
        { id: 43, title: "Rate Limit", path: "/manage/ratelimit", category: "Settings", icon: <MdOutlineAdminPanelSettings size={18} />, color: "text-orange-500" },
        { id: 44, title: "Account Delete Request (Web)", path: "/web/delete/user", category: "Settings", icon: <RiDeleteBin6Line size={18} />, color: "text-red-500" },
    ];

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
                setSuggestions([]);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Keyboard navigation
    const handleKeyDown = (e) => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setSelectedIndex(prev => (prev < suggestions.length - 1 ? prev + 1 : prev));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setSelectedIndex(prev => (prev > 0 ? prev - 1 : 0));
        } else if (e.key === 'Enter' && selectedIndex >= 0) {
            e.preventDefault();
            handleSelect(suggestions[selectedIndex].path);
        } else if (e.key === 'Escape') {
            setIsOpen(false);
            setSuggestions([]);
            inputRef.current?.blur();
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setQuery(value);
        setSelectedIndex(-1);

        if (!value) {
            setSuggestions([]);
            setIsOpen(false);
            return;
        }

        const filtered = searchItems.filter(item =>
            item.title.toLowerCase().includes(value.toLowerCase()) ||
            item.category.toLowerCase().includes(value.toLowerCase())
        );
        setSuggestions(filtered.slice(0, 8));
        setIsOpen(true);
    };

    const handleSelect = (path) => {
        navigate(path);
        setQuery('');
        setSuggestions([]);
        setIsOpen(false);
    };

    const handleClear = () => {
        setQuery('');
        setSuggestions([]);
        setIsOpen(false);
        inputRef.current?.focus();
    };

    const handleFocus = () => {
        if (query) {
            setIsOpen(true);
        }
    };

    // Group suggestions by category
    const groupedSuggestions = suggestions.reduce((acc, item) => {
        if (!acc[item.category]) {
            acc[item.category] = [];
        }
        acc[item.category].push(item);
        return acc;
    }, {});

    return (
        <div ref={containerRef} className="relative w-full">
            {/* Search Input */}
            <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FiSearch style={{ color: '#888B91' }} size={18} />
                </div>
                <input
                    ref={inputRef}
                    type="text"
                    value={query}
                    onChange={handleSearch}
                    onKeyDown={handleKeyDown}
                    onFocus={handleFocus}
                    placeholder="Search pages..."
                    style={{
                        backgroundColor: '#F9FAFE',
                        borderColor: '#CFD1D3',
                        color: '#111723'
                    }}
                    className="w-full pl-10 pr-10 py-2.5 border rounded-xl 
                        focus:outline-none focus:ring-2 focus:ring-[#34C759]/20 focus:border-[#34C759] 
                        text-sm placeholder-gray-400
                        transition-all duration-200"
                />
                {query && (
                    <button
                        onClick={handleClear}
                        style={{ color: '#888B91' }}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center hover:text-gray-600 transition-colors"
                    >
                        <FiX size={18} />
                    </button>
                )}
            </div>

            {/* Suggestions Dropdown */}
            {isOpen && suggestions.length > 0 && (
                <div
                    style={{ backgroundColor: '#FFFFFF', borderColor: '#CFD1D3' }}
                    className="absolute top-full left-0 right-0 mt-2 rounded-xl shadow-xl border overflow-hidden z-50 max-h-[400px] overflow-y-auto"
                >
                    {Object.entries(groupedSuggestions).map(([category, items], categoryIndex) => (
                        <div key={category}>
                            {/* Category Header */}
                            <div style={{ backgroundColor: '#F9FAFE', borderColor: '#CFD1D3' }} className="px-4 py-2 border-b">
                                <span style={{ color: '#888B91' }} className="text-xs font-semibold uppercase tracking-wide">
                                    {category}
                                </span>
                            </div>

                            {/* Category Items */}
                            {items.map((item) => {
                                const globalIndex = suggestions.findIndex(s => s.id === item.id);
                                const isSelected = globalIndex === selectedIndex;

                                return (
                                    <div
                                        key={item.id}
                                        style={{
                                            backgroundColor: isSelected ? '#f2fcf5' : '#FFFFFF',
                                            borderLeftColor: isSelected ? '#34C759' : 'transparent'
                                        }}
                                        className={`px-4 py-3 cursor-pointer flex items-center justify-between group transition-all duration-150 border-l-2 hover:bg-gray-50`}
                                        onClick={() => handleSelect(item.path)}
                                        onMouseEnter={() => setSelectedIndex(globalIndex)}
                                    >
                                        <div className="flex items-center gap-3">
                                            <div
                                                style={{ backgroundColor: '#F9FAFE' }}
                                                className={`p-2 rounded-lg group-hover:bg-white transition-colors ${item.color}`}
                                            >
                                                {item.icon}
                                            </div>
                                            <div>
                                                <p style={{ color: isSelected ? '#34C759' : '#111723' }} className="text-sm font-medium">
                                                    {item.title}
                                                </p>
                                                <p style={{ color: '#888B91' }} className="text-xs truncate max-w-[200px]">
                                                    {item.path}
                                                </p>
                                            </div>
                                        </div>
                                        <FiArrowRight
                                            style={{ color: isSelected ? '#34C759' : '#CFD1D3' }}
                                            className={`transition-all duration-200 
                                                ${isSelected ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0'}
                                            `}
                                            size={16}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    ))}

                    {/* Footer */}
                    <div style={{ backgroundColor: '#F9FAFE', borderColor: '#CFD1D3' }} className="px-4 py-2 border-t flex items-center justify-between">
                        <span style={{ color: '#888B91' }} className="text-xs">
                            {suggestions.length} result{suggestions.length !== 1 ? 's' : ''} found
                        </span>
                        <div className="flex items-center gap-2">
                            <kbd style={{ backgroundColor: '#CFD1D3', color: '#888B91' }} className="px-1.5 py-0.5 text-xs rounded">↑↓</kbd>
                            <span style={{ color: '#888B91' }} className="text-xs">navigate</span>
                            <kbd style={{ backgroundColor: '#CFD1D3', color: '#888B91' }} className="px-1.5 py-0.5 text-xs rounded ml-2">↵</kbd>
                            <span style={{ color: '#888B91' }} className="text-xs">select</span>
                        </div>
                    </div>
                </div>
            )}

            {/* No Results */}
            {isOpen && query && suggestions.length === 0 && (
                <div
                    style={{ backgroundColor: '#FFFFFF', borderColor: '#CFD1D3' }}
                    className="absolute top-full left-0 right-0 mt-2 rounded-xl shadow-xl border overflow-hidden z-50"
                >
                    <div className="px-4 py-8 text-center">
                        <div style={{ backgroundColor: '#F9FAFE' }} className="rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-3">
                            <FiSearch style={{ color: '#888B91' }} size={20} />
                        </div>
                        <p style={{ color: '#111723' }} className="text-sm font-medium">No results found</p>
                        <p style={{ color: '#888B91' }} className="text-xs mt-1">Try searching with different keywords</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UniversalSearchBar;